export const API_URLS = {
  GLOBAL_USERS: "users",
  USERS_BY_APP: "users-by-application",
  ROLES_BY_APP: (id) => `application/${id}`,
  USER_UPDATE_ROLE: "user-update-role",
  MAINTENANCE: "application/check-maintenance",
  AUTH_SSO: "authSSO",
  MAPS: (id) => `maps/${id}`,
  NEW_MAP: "map",
  MAP: (id) => `map/${id}`,
  NEW_ROUTE: "route",
  ROUTE: (id) => `route/${id}`,
  SECTION_TYPES: "sectionsTypes",
  SUB_SECTIONS: "subSections",
  SU_OPTIONS: "subOptions",
  NEW_SECTION: "section",
  SECTION: (id) => `section/${id}`,
  SALES_ITEM: "salesitem/communications/RU/ES",
  DELETE_MAP: "map-reset",
  ITEMS_MOTIONS: "itemsToMotion",
  MOTION: (id) => `motion/${id}`,
  NEW_MOTION: "motion",
  ACTIONS: "actions",
  NEW_ACTION: "action",
  ACTION: (id) => `action/${id}`,
  STORES: "stores",
  MOTIONS: "motions",
  MOTIONS_DYNAMIC: "motions/dynamic",
  STATISTICS: (storeId) => `statistics/goals/${storeId}`,
  LANGUAGES: (countryCode) => `languages/${countryCode}`,
};